import gql from 'graphql-tag'

export const companyCreateUserAccess = gql`
  mutation companyCreateUserAccess($companyId: ID!, $userId: ID!) {
    companyCreateUserAccess(input: { companyId: $companyId, userId: $userId }) {
      success
    }
  }
`
